import Api from '@/domain/api';

import { TRAIL_PANEL_FILTERS_INITIAL, type TrailPanelFilters } from '@/domain/events/params';

export type { TrailPanelFilters };

export interface TrailFilterOptionPlain {
  label: string;
  value: string;
  picture?: string | null;
}

export const AP_TRAIL_FILTERS_INITIAL = TRAIL_PANEL_FILTERS_INITIAL;

export const fetchApTrailFilterOptions = async (): Promise<{
  users: TrailFilterOptionPlain[];
  types: TrailFilterOptionPlain[];
}> => {
  const { data } = await Api.getEventFilters();
  return { users: data?.users ?? [], types: data?.types ?? [] };
};

export const toApFilterPayload = (filters: TrailPanelFilters) => ({
  usersSearch: filters.users,
  typesSearch: filters.types,
  textsSearch: filters.texts,
  freeTextSearch: filters.freeText ? [filters.freeText] : [],
});
